<template>
  <div>
    <div class="title_parcours">
      <h2 class="align_left">
        <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
        {{ parcours.nom }}
      </h2>

      <div class="statut_course">
        <p v-if="parcours.depart == 0">Départ prévu le {{ parcours.date_course }} à {{ parcours.heure_depart_theorique
        }}</p>
        <p v-else-if="parcours.depart == 1 && parcours.terminee == 0">Parti le {{ parcours.date_course }} à {{
          parcours.heure_depart }}</p>
        <p v-else-if="parcours.terminee == 1">Course terminée</p>
      </div>
    </div>

    <div class="list_puce_stats_parcours">
      <div class="puce_stats_parcours">
        <p class="value_puce">{{ parcours.statistique.inscrits }} Inscrits</p>
      </div>
      <div class="puce_stats_parcours">
        <p class="value_puce">{{ parcours.statistique.pris_depart }} partants</p>
      </div>
      <div class="puce_stats_parcours">
        <p class="value_puce">{{ parcours.statistique.en_course }} en course</p>
      </div>
      <div class="puce_stats_parcours">
        <p class="value_puce">{{ parcours.statistique.arrives }} arrivés</p>
      </div>

      <b-button class="inline-btn" v-if="!display_list_abandons" @click="display_list_abandons = true">+ Voir les {{
        parcours.statistique.abandons }} abandons</b-button>
      <b-button class="inline-btn" v-else @click="display_list_abandons = false">- Fermer les {{
        parcours.statistique.abandons }} abandons</b-button>
      <b-button class="inline-btn" v-if="!display_list_disqualifies" @click="display_list_disqualifies = true">+ Voir
        les
        {{ parcours.statistique.disqualifie }} disqualifiés</b-button>
      <b-button class="inline-btn" v-else @click="display_list_disqualifies = false">- Fermer les {{
        parcours.statistique.disqualifie }} disqualifiés</b-button>
    </div>
    <div class="sep"></div>
    <div v-if="display_list_abandons">
      <h4>Les abandons</h4>

      <b-table :items="parcours.list_abandons" :fields="['dossard', 'nom', 'prenom', 'fiche_coureur']" small responsive
        tbody-tr-class="missing_row">
        <template #cell(nom)="data"> {{ data.item.nom }}</template>
        <template #cell(prenom)="data">
          {{ data.item.prenom }}
        </template>
        <template #cell(dossard)="data">
          {{ data.item.dossard }}
        </template>
        <template #cell(fiche_coureur)="data">
          <b-button class="inline-btn with_icon" @click="openFicheCoureur(data)"><b-icon icon="person"
              aria-hidden="true"></b-icon> Ouvrir sa fiche</b-button>
        </template>
      </b-table>
    </div>
    <div v-if="display_list_disqualifies">
      <h4>Les disqualifiés</h4>

      <b-table :items="parcours.list_disqualifies" :fields="['dossard', 'nom', 'prenom', 'fiche_coureur']" small
        responsive tbody-tr-class="missing_row">
        <template #cell(nom)="data"> {{ data.item.nom }}</template>
        <template #cell(prenom)="data">
          {{ data.item.prenom }}
        </template>
        <template #cell(dossard)="data">
          {{ data.item.dossard }}
        </template>
        <template #cell(fiche_coureur)="data">
          <b-button class="inline-btn with_icon" @click="openFicheCoureur(data)"><b-icon icon="person"
              aria-hidden="true"></b-icon> Ouvrir sa fiche</b-button>
        </template>
      </b-table>
    </div>
    <b-table class="align_left" responsive :items="parcours.list_points.list" :fields="fields"
      :tbody-tr-class="rowClass">
      <template #cell(nom)="data">
        {{ data.item.nom_affiche }}
      </template>
      <template #cell(box)="data">
        {{ data.item.nom_box_reel }}
      </template>
      <template #cell(coureur_attendu)="data">
        {{ data.item.statistique.nb_attendu }}
      </template>
      <template #cell(coureur_passe)="data">
        {{ data.item.statistique.nb_passe }}
      </template>
      <template #cell(coureur_restant)="data">
        <b v-if="data.item.statistique.nb_restant == 0">{{ data.item.statistique.nb_restant }}</b>
        <div v-else>
          <b>{{ data.item.statistique.nb_restant }}</b>
          <b-btn class="inline-btn" @click="data.toggleDetails"><span v-if="data.detailsShowing">Masquer</span><span
              v-else>Afficher</span></b-btn>
        </div>
      </template>
      <template #row-details="row">
        <b-card>
          <p>
            Coureurs restants au point: <b>{{ row.item.nom_affiche }}</b>
          </p>
          <p v-if="row.item.coureurs_attendus.length > 10">
            <i>
              <b-icon icon="exclamation-circle-fill" class="primary_color" aria-hidden="true"></b-icon>
              Il y a plus de 10 coureurs restants au point, la liste est tronquée
            </i>
          </p>
          <div v-if="row.item.coureurs_attendus.length > 10">
            <b-btn class="inline-btn" v-if="nb_attendu_to_display != 50" @click="nb_attendu_to_display = 50">En afficher
              plus</b-btn>
            <b-btn class="inline-btn" v-else @click="nb_attendu_to_display = 10">En afficher moins</b-btn>
          </div>

          <b-table
            :items="nb_attendu_to_display == 10 ? row.item.coureurs_attendus.slice(0, nb_attendu_to_display) : row.item.coureurs_attendus"
            :fields="['dossard', 'nom', 'prenom', 'fiche_coureur']" small responsive>
            <template #cell(nom)="data"> {{ data.item.nom }}</template>
            <template #cell(prenom)="data">
              {{ data.item.prenom }}
            </template>
            <template #cell(dossard)="data">
              {{ data.item.dossard }}
            </template>
            <template #cell(fiche_coureur)="data">
              <div class="d-flex flex-row align-items-center">
                <div v-if="data.item.passage_suivant">

                  <p class="text-danger">
                    <b>Coureur passé à un point suivant</b>
                  </p>

                </div>
                <b-button class="inline-btn with_icon" @click="openFicheCoureur(data)"><b-icon icon="person"
                    aria-hidden="true"></b-icon> Ouvrir sa fiche</b-button>
              </div>
            </template>
          </b-table>
        </b-card>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: ["parcours"],
  data() {
    return {
      display_list_abandons: false,
      display_list_disqualifies: false,
      nb_attendu_to_display: 10,
      fields: [
        { key: "nom", label: "Point" },
        { key: "coureur_attendu", label: "Coureurs attendus" },
        { key: "coureur_passe", label: "Coureurs passés" },
        { key: "coureur_restant", label: "Coureurs restants" },
      ],
    };
  },
  methods: {
    openFicheCoureur(data) {
      var fiche_path = "fiche/" + data.item.id;
      this.$router.push({ path: fiche_path });
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.statistique.nb_restant == 0) return "clear_row";
      if (item.statistique.nb_restant > 0) return "missing_row";
    },
  },
};
</script>

<style lang="scss" scoped></style>